export default __webpack_public_path__ + "static/events-light-7fa2f54c623abead02c75525898007c4.png";